import React from 'react';
import './Checkbox.css';

const Checkbox = ({
  anounceError = true,
  checked = false,
  children,
  className = '',
  containerClassName = '',
  error = false,
  errorClassName = '',
  errorMessage = '',
  id = '',
  keepSpaceError = false,
  name = '',
  onClick = () => { },
  readOnly = false,
  small = false,
}) => (
  <div
    className={`Checkbox-main-container ${containerClassName}`}
    data-small={small}
  >
    <label
      className={`Checkbox-container Checkbox-label ${className}`}
      data-error={!!error}
      htmlFor={id}
    >
      <input
        aria-describedby={`checkbox-error-${id}`}
        aria-labelledby={`${id}-label`}
        checked={checked}
        className="Checkbox-input"
        data-error={!!error}
        id={id}
        name={name}
        onChange={onClick}
        readOnly={readOnly}
        type="checkbox"
      />

      <p id={`${id}-label`}>
        {children}
      </p>
    </label>

    <span
      aria-live={anounceError ? 'polite' : 'off'}
      className={`Checkbox-error-label ${errorClassName}`
        + ` ${keepSpaceError ? ' Checkbox-keep-space' : ''}`}
      id={`checkbox-error-${id}`}
    >
      {error && errorMessage}
    </span>
  </div>
);

export default Checkbox;
